"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _utils = require("./utils");
var _excluded = ["component", "href", "eventProps", "newWindow", "onClick", "rel"];
var ClickWrapper = function ClickWrapper(_ref) {
  var Component = _ref.component,
    href = _ref.href,
    _ref$eventProps = _ref.eventProps,
    eventProps = _ref$eventProps === void 0 ? {} : _ref$eventProps,
    _ref$newWindow = _ref.newWindow,
    newWindow = _ref$newWindow === void 0 ? true : _ref$newWindow,
    _ref$onClick = _ref.onClick,
    _onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    _ref$rel = _ref.rel,
    rel = _ref$rel === void 0 ? 'sponsored' : _ref$rel,
    restProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var constructURL = (0, _react.useMemo)(function () {
    return (0, _utils.createLink)({
      href: href,
      eventProps: eventProps
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(eventProps), href]);
  var desiredRel = rel;
  if (!desiredRel) {
    // this is just in case a rel has been passed in as null or empty string
    // since the default value should be picked up if undefined
    // we should always set a rel for SEO
    desiredRel = 'sponsored';
  }
  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, restProps, {
    onClick: function onClick() {
      if (_onClick) {
        _onClick();
      }
    },
    href: constructURL,
    target: newWindow ? '_blank' : '_self'
    // this rel should only be on <a> or <link> but we don't
    // know if the component is a react component that sets it on those
    // elements
    ,
    rel: desiredRel
  }));
};
var _default = ClickWrapper;
exports.default = _default;